import { upload } from '@/api/uploadFile'
import { isImage, blobToBase64, transferFileSize } from '@/utils/extend'

const UploadFile = {
  namespaced: true,
  state: {
    fileList: [],
    contentLimit: 120000
  },
  mutations: {
    SET_FILELIST: (state, val) => {
      state.fileList = val
    },
    SET_FILE: (state, payload) => {
      for (const k in payload.val) {
        state.fileList[payload.index][k] = payload.val[k]
      }
    },
    ADD_FILELIST: (state, val) => {
      state.fileList = state.fileList.concat(val)
    },
    ADD_FILE: (state, val) => {
      state.fileList.push(val)
    },
    RESET_DATA: state => {
      state.fileList = []
    }
  },
  getters: {
    isUploading(state) {
      return state.fileList.filter(item => !item.finish && !item.error).length
    },
    totalLength(state) {
      return state.fileList.filter(item => item.finish).reduce((acc, cur) => acc + cur.length, 0)
    },
    contentOverPercent(state, getters) {
      const over = getters.totalLength - state.contentLimit
      return parseFloat(((Math.max(over, 0) * 100) / state.contentLimit).toFixed(2))
    },
    maxReadPercent(state, getters) {
      const per = parseFloat(((state.contentLimit * 100) / getters.totalLength).toFixed(2))
      if (getters.contentOverPercent > 0) {
        state.fileList[0].maxReadPercent = per
      }
      return per
    }
  },
  actions: {
    async beforeUpload({ commit, state, getters }, file) {
      const isimage = isImage(file.name)
      let imageurl = ''
      if (isimage) {
        imageurl = await blobToBase64(file)
      }
      return new Promise((resolve, reject) => {
        console.log(file)
        const name = file.name.substring(0, file.name.lastIndexOf('.'))
        const type = file.name.substring(file.name.lastIndexOf('.') + 1)
        const isLt20M = file.size / 1024 / 1024 <= 20
        if (!isLt20M) {
          window.VueInstance.config.globalProperties.$message.error('上传文件大小不能超过 20MB!')
          reject(false)
        } else if (getters.contentOverPercent > 0 && state.fileList.length > 1) {
          window.VueInstance.config.globalProperties.$message.error(
            '上传文件内容超出限制，请删减部分文档'
          )
          reject(false)
        } else {
          const item = {
            id: '',
            uid: file.uid,
            wholeName: file.name,
            name,
            size: file.size,
            transferFileSize: transferFileSize(file.size),
            length: 0,
            url: '',
            isimage,
            imageurl,
            type: type,
            finish: false,
            error: false,
            retryFile: file,
            loading: !!imageurl,
            maxReadPercent: 0
          }
          commit('ADD_FILE', item)
          resolve(true)
        }
      })
    },
    uploadFile({ state, commit, rootGetters, dispatch }, file) {
      const isSyncStorage = rootGetters['Home/isSyncStorage']
      const isBeta = rootGetters['Home/isBeta']
      const index = state.fileList.findIndex(item => item.uid === file.uid)
      const isImage = state.fileList[index].isimage
      const imageurl = state.fileList[index].imageurl
      return new Promise((resolve, reject) => {
        upload({ file: file })
          .then(res => {
            console.log(res)
            if (res.status === 0) {
              if (res.result.file_url) {
                commit('SET_FILE', {
                  index,
                  val: {
                    url: res.result.file_url,
                    imageurl: isImage ? res.result.file_url : imageurl,
                    id: res.result.file_id,
                    length: res.result.content_length || 0
                  }
                })
              }
              commit('SET_FILE', { index, val: { finish: true } })
              if (isSyncStorage && isBeta && localStorage.getItem('chooseCloudSyncDialog')) {
                dispatch(
                  'CloudKnowledge/syncCloud',
                  {
                    file_url: res.result.file_url,
                    file_name: res.result.file_name,
                    content_length: res.result.content_length || 0
                  },
                  { root: true }
                )
                  .then(res1 => {
                    resolve(res1)
                  })
                  .catch(err => {
                    reject(err)
                  })
              } else {
                resolve(res)
              }
            } else {
              commit('SET_FILE', { index, val: { error: true } })
              reject()
            }
          })
          .catch(err => {
            console.log(err)
            commit('SET_FILE', { index, val: { error: true } })
            reject()
          })
      })
    },
    handleDelete({ state, commit }, file) {
      const fileList = state.fileList.filter(item => item.uid !== file.uid)
      commit('SET_FILELIST', fileList)
      window.VueInstance.config.globalProperties.$message.success('删除成功')
    },
    handleRetry({ state, commit, dispatch }, file) {
      const index = state.fileList.findIndex(item => item.uid === file.uid)
      commit('SET_FILE', { index, val: { error: false, finish: false } })
      dispatch('uploadFile', file.retryFile)
    }
  }
}

export default UploadFile
